import type { Language } from '../types/language';
import { Language as ELanguage } from '../enums/language';

export const getLanguages = (): Language[] => [
  { key: ELanguage.En, label: 'English' },
  { key: ELanguage.Sv, label: 'Svenska' },
  { key: ELanguage.Fr, label: 'Français' },
  { key: ELanguage.Da, label: 'Dansk' },
  { key: ELanguage.No, label: 'Norsk' },
  { key: ELanguage.Es, label: 'Español' },
  { key: ELanguage.Nl, label: 'Nederlands' },
  { key: ELanguage.De, label: 'Deutsch' },
  { key: ELanguage.Fi, label: 'Suomi' },
  { key: ELanguage.Pt, label: 'Português' },
];
